import { Commitment } from "./commitment.model";
import { imageLoad } from "./development.model";
import { Funding } from "./funding.model";
import { Schedule } from "./schedule.model";

export class Project {
  public estimatedBudget = 0;
  public fieldInspector = "To Be Determined";
  public buildings: string[] = [];
  public generalContractor = "To Be Determined";
  public vendors: Vendor[] = [];
  public projectImage: imageLoad[] = [];
  public projectVendors = "To Be Determined";
  constructor(
    public id: string,
    public name: string,
    public projectStatus: string,
    public scopeOfWork: string,
    public developmentId: number,
    public developmentName: string,
    public deliveryType: string,
    public manager: string,
    public projectUpdate: string,
    public updatedDate: Date,
    public department: string,
    public areaOfWork: string,
    public funding: Funding[] = [],
    public schedule: Schedule[] = [],
    public otherDevelopments: number[] = [],
    public projectPicture?: string,
    public _supervisor?: string,
    public allBuildings?: string,
    public startYear?: string,
    public commitment: Commitment[] = [],
    public projectLocation: string = "",
    public projectTotalBudget: number = 0,
  ) {
    // console.log({ id: id, otherDevelopments: otherDevelopments, developmentName: developmentName });

    this.estimatedBudget = otherDevelopments.length > 1 ? 0 : funding[0]?.totalFunds || 0;

    // this.supervisor = _supervisor ?? "To Be Determined";
    this.fieldInspector = [
      ...new Set(commitment
      .filter((x) => x.commitmentType.toLocaleUpperCase() === "CM")
      .flatMap((x) => x.companyName))]
      .join(", ");

    if (!this.fieldInspector)
      this.fieldInspector = [
        ...new Set(
          commitment
            .filter((x) => x.commitmentType.toUpperCase() !== "CM")
            .flatMap((x) => x.fieldInspector),
        ),
      ].join(", ");

    this.generalContractor = [
      ...new Set(commitment
      .filter((x) => x.commitmentType.toLocaleUpperCase() === "CONTRACTOR")
      .flatMap((x) => x.companyName))]
      .join(", ");

    this.projectVendors = [
      ...new Set(commitment
      .filter((x) => x.commitmentType.toLocaleUpperCase() === "AE")
      .flatMap((x) => x.companyName))]
      .join(", ");

    // this.buildings = allBuildings?.replaceAll(this.developmentName + " - ", "").split(",") ?? [];

    this.buildings =
      projectLocation.toLocaleLowerCase() === "residential building"
        ? this.formatProjectlocation(allBuildings ?? "") ?? []
        : [projectLocation];
  }

  formatProjectlocation(allBuilding: string): string[] {
    const buildingLocation: string[] = [];
    allBuilding.split(",").forEach((location) => {
      const parts = location.split(" - ");
      if (parts.length === 3) {
        buildingLocation.push(`${parts[0]} - ${parts[2]}`);
      } else {
        buildingLocation.push(location?.replaceAll(this.developmentName + " - ", ""));
      }
    });
    return buildingLocation;
  }
}

interface Vendor {
  field: string;
  companyName: string;
}

export interface DropDown {
  id: string;
  label: string;
  checked?: boolean;
}
